import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import * as moment from 'moment';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'datepicker-container',
  templateUrl: 'datepicker.html'
})

export class DatePickerComponent implements OnInit {

  //@ViewChild(MdDatepicker) dp: MdDatepicker<Date>;
  @Input() idInput;
  @Output() clickedInput = new EventEmitter();
  private _subject = new Subject<any>();
  public dt: Date = void 0;
  public todayD: Date;
  public minDate: Date = void 0;
  public maxDate: Date = void 0;
  public tomorrow: Date;
  public dateDisabled: {date: Date, mode: string}[];
  
  public opened: boolean = false;
  public formatDate;
 
  public constructor(private elementRef: ElementRef) {
    this.todayD = new Date();
    (this.dateDisabled = []);
    //(this.minDate = new Date()).setDate(this.todayD.getDate() - 60);
    //(this.maxDate = new Date()).setDate(this.todayD.getDate() + 60);

  }

  public openDatePicker(){
    this.opened = true;
    this.clickedInput.emit(this.idInput);
  }

  public closeDatePicker($event) {
      if($event.relatedTarget == null || $event.relatedTarget.type == "text" ){
        this.opened = false;
      }
  }
 
  public getDate() {
      if(this.dt != null){
        return this.formatDate = moment(this.dt).format("DD/MM/YYYY");
      }
      return '';
  }

  public setDate(value) {
    this.dt = moment(value,"DD-MM-YYYY").toDate();
  }
 
  public today(): void {
    this.dt = moment("YYYY-MM-DD").toDate();
  }

  public disableTomorrow(): void {
    this.dateDisabled = [{date: this.tomorrow, mode: 'day'}];
  }
 
  public dateChange(event){
    this.opened = false;
  }
  public disabled(date: Date, mode: string): boolean {
    return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
  }

  ngOnInit() {
      //console.log(this.elementRef);
      var array = this.idInput.split("/");
      //console.log(array);
      if(array.length > 1) this.setDate(this.idInput);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/datepicker/datepicker.component.ts